import { render, staticRenderFns } from "./MigrationOnline.vue?vue&type=template&id=95b85ee8&"
import script from "./MigrationOnline.vue?vue&type=script&lang=js&"
export * from "./MigrationOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MigrationOnline.vue"
export default component.exports